module.exports = __webpack_public_path__ + "static/media/insta.7740c5d8.png";